import * as React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import MaterialTable, { Column, MTableToolbar } from 'material-table';
import Button from '@material-ui/core/Button';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import DescriptionSharpIcon from '@material-ui/icons/DescriptionSharp';
import { forwardRef } from 'react';
import { Icons } from 'material-table';
import {
    Tooltip,
    IconButton,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    DialogProps,
    Popover,
    Typography,
    FormControlLabel,
    withStyles, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Badge, RadioGroup, Radio, Box
} from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Checkbox from '@material-ui/core/Checkbox';
import CircularProgress from '@material-ui/core/CircularProgress';
import VisibilityIcon from '@material-ui/icons/Visibility';
import RedoIcon from '@material-ui/icons/Redo';
import { ManufacturerData, TatData } from 'src/reducers/fileUpload';
import { PreviewOrderData, RowDataManufactur } from 'src/reducers/manufactur';
import ThumbsUpDownRoundedIcon from '@material-ui/icons/ThumbsUpDownRounded';
import ScrollToBottom from 'react-scroll-to-bottom';
import ThreeDRotationIcon from '@material-ui/icons/ThreeDRotation';
import TrackChangesTwoToneIcon from '@material-ui/icons/TrackChangesTwoTone';
import MailOutlineIcon from '@material-ui/icons/MailOutline';

import { RedesignReasons } from 'src/reducers/completeorderfile';
import { UserDetail } from 'src/reducers/user';
import { GetFileData } from 'src/reducers/rxForm';
import PlayCircleFilledTwoToneIcon from '@material-ui/icons/PlayCircleFilledTwoTone';
import AutorenewIcon from '@material-ui/icons/Autorenew';
import Fab from '@material-ui/core/Fab';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import { CSVLink } from 'react-csv';

interface TableStateDate {
    columns: Array<Column<RowDataManufactur>>;
    data: RowDataManufactur[];
}

interface SubitReDesignCodes {
    producttype: string;
    category: string;
    reason: string;
}

export interface MFilterLessOrderViewProps {
    mfilteredOrderData: RowDataManufactur[];
    mfiltersdataExport: RowDataManufactur[];
    isDownloading: boolean;
    redesignReasons: RedesignReasons[];
    reload: () => void;
    onRowClick: (orderid: string, rowData: string) => void;
    onDownloadClick: (filePath: string, fileName: string) => void;
    // onBulkDownload: (completedData: RowDataManufactur[] | RowDataManufactur) => void;
    // onBulkDownloadStl: (completedData: RowDataManufactur[] | RowDataManufactur, filetype: string) => void;
    // onBulkDownloadIndividual: (completedData: RowDataManufactur[] | RowDataManufactur) => void;
    onBulkDownload: (completedData: RowDataManufactur[] | RowDataManufactur, isRetry?: boolean) => void;
    onBulkDownloadIndividual: (completedData: RowDataManufactur[] | RowDataManufactur, isRetry?: boolean) => void;
    onBulkDownloadStl: (completedData: RowDataManufactur[] | RowDataManufactur, filetype: string) => void;
    fromDate: (fromdate: string) => void;
    toDate: (todate: string) => void;
    dateFilter: () => void;
    dateReset: () => void;
    orderDataTat: TatData[];
    orderDataManufacturer: ManufacturerData[];
    approvalRequired: (array: Array<object>) => void;
    redesignRequest: (columns: Object) => void;

    downloadFile: (filepath: string, filename: string, status: string) => void;

    caseFilter: (fcaseno: string, tcaseno: string, startDate: Date | null, endDate: Date | null, status: string) => void;
    caseFilterCust: (fcaseno: string, tcaseno: string) => void;

    userDetails: UserDetail;
    supportPage: (order: string) => void;

    getPreviewData: (orderno: string) => void;
    resetPreviewData: () => void;
    previewOrderData: PreviewOrderData;
    msgAtt: (msgAttachment: string) => void;
    goStlViewer: (data: GetFileData[]) => void;
    openVideoPlayerURL: (fullPath: string[], fpath: string) => void;
    failedFiles: Array<{ fname: string; orderno: string; fileType?: string; caseCount?: number }>;
    showFailedFilesDialog: boolean;
    failedFilesMessage: string;
    closeFailedFilesDialog: () => void;
}
export const tableIcons: Icons = {
    Export: forwardRef((props, ref) => <DescriptionSharpIcon {...props} ref={ref} />)
};

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
            height: 'calc(90vh - 64px)'
        },
        table: {
            // margin: theme.spacing(1),
            minWidth: 800,
        },
        forms: {
            width: '100%', // Fix IE 11 issue.
        },
        buttonSend: {
            // margin: theme.spacing(1),
            float: 'right',
            zIndex: 100,
            margin: '12px',
            position: 'relative'
        },
        root1: {
            display: 'flex',
            height: '30vh'
        },
        fileUpload: {
            textAlign: 'center',
            fontSize: '18px',
            color: '#808080',
            height: '20vh',
            border: '2px solid #808080',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderStyle: 'dotted',
            '&:hover': {
                border: '4px solid #ff0000'
            }
        },
        iconbutton: {
            display: 'flex',
            '& > *': {
                margin: theme.spacing(1),
            },
            justifyContent: 'space-between'
        },
        modal: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        paper: {
            backgroundColor: theme.palette.background.paper,
            borderRadius: '5px',
            boxShadow: theme.shadows[5],
            padding: theme.spacing(1),
        },
        HeadinG: {
            margin: theme.spacing(1),
            '& .MuiInputBase-input': {
                fontSize: '0.9rem'
            },
            '& .MuiButton-label': {
                fontSize: '0.7rem'
            },
            fontSize: '0.9rem'
        },
        reasonBox: {
            minWidth: '500px'
        },
        qcreq: {
            fontSize: '10px',
            textAlign: 'right',
            paddingRight: '24px',
            fontStyle: 'italic',
            color: 'red'
        },
        button: {
            margin: theme.spacing(1),
        },
        mtable: {
            '& .MuiButton-root': {
                fontSize: '12px',
                textTransform: 'capitalize'
            },
            '& .MuiIconButton-root': {
                padding: '0px 5px',
                borderRadius: '0%',
                '&:hover': {
                    backgroundColor: 'transparent'
                }
            }
        },
        dialog: {
            margin: theme.spacing(2)
        },
        tabpanel: {
            margin: theme.spacing(2, 0),
            maxHeight: '260px',
            overflowY: 'auto'
        },
        fileHover: {
            cursor: 'pointer',
            color: '#3F51B5',
            '&:hover': {
                cursor: 'pointer',
                color: '#3F51B5'
            },
        },
        previewOrderfont: {
            fontSize: '12px',
            display: 'grid'
        },
        bubble: {
            display: 'inline-block',
        },
        bubbleReciver: {
            display: 'inline-block',
        },
        right: {
            textAlign: 'right',
            margin: '12px 12px'
        },
        left: {
            textAlign: 'left',
            margin: '12px 12px'
        },
        message: {
            fontWeight: 500
        },
        date: {
            fontSize: '12px'
        },
        imageHeight: {
            height: '50px'
        },
        mfrom: {
            fontWeight: 'bolder',
            color: '#4F93FE'
        },
        mto: {
            fontWeight: 'bolder',
            color: '#38C7D8'
        },
        textField: {
            margin: '0px !important'
        },
        chatBotWidth: {
            width: '50%'
        },
        attachment: {
            fontSize: '12px',
            cursor: 'pointer',
            '&:hover': {
                cursor: 'pointer',
                color: '#3F51B5'
            },
        },
        container: {
            bottom: 0,
            height: '240px',
            overflow: 'auto'
            // position: "fixed" // remove this so we can apply flex design
        },
        exportButton: {
            textDecoration: 'none',
            fontSize: '0.4rem',
            '&:hover': {
                textDecoration: 'none'
            },
            '&:link': {
                textDecoration: 'none'
            }
        },
        exportIcon: {
            fontSize: '20px',
            fill: 'white'
        }
    })
);

const CssTextField = withStyles({
    root: {
        '& .MuiInputBase-root.Mui-disabled': {
            color: '#000',
        },
    },
})(TextField);

const CssTextFieldRedesign = withStyles({
    root: {
        '& .MuiInputBase-root.Mui-disabled': {
            color: '#000',
            fontSize: '0.9rem'
        },
    },
})(TextField);

const MFilterLessOrderView: React.StatelessComponent<MFilterLessOrderViewProps> = (props) => {
    const classes = useStyles({});

    const [fullWidth] = React.useState(true);
    const [maxWidth] = React.useState<DialogProps['maxWidth']>('sm');
    const [fullWidthReason] = React.useState(true);
    const [maxWidthReason] = React.useState<DialogProps['maxWidth']>('md');
    const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);

    const [tat, setTat] = React.useState('Next Day 7 AM');
    const [manufactType, saveManufactType] = React.useState('In-House');
    const [ptype, setPtype] = React.useState('');
    const [ptypeModel, setPtypeModel] = React.useState('');
    const [category, setCategory] = React.useState('');
    const [categoryArray, setCategoryArray] = React.useState<string[]>([]);
    const [categoryModelArray, setCategoryModelArray] = React.useState<string[]>([]);
    const [categoryModel, setCategoryModel] = React.useState('');
    const [reason, setReason] = React.useState<SubitReDesignCodes[]>([]);
    const [reasonModel, setReasonModel] = React.useState<SubitReDesignCodes[]>([]);
    const [msg, setMsg] = React.useState('');
    const [msgApp, setMsgApp] = React.useState('');
    const [orderno, setOrderno] = React.useState('');
    const [userName, setuserName] = React.useState('');

    const popoverClick = (event: React.MouseEvent<HTMLButtonElement>, rowDataVal: RowDataManufactur) => {
        setOrderno(rowDataVal.orderno);
        setuserName(rowDataVal.labname);
        saveManufactType(rowDataVal.destination || '');
        setAnchorEl(event.currentTarget);
    };

    const popoverClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    const [openRe, setOpenRe] = React.useState(false);
    const [openDesignReason, setOpenDesignReason] = React.useState(false);
    const [openModelReason, setOpenModelReason] = React.useState(false);

    const duplicateCateDesign = (data: RedesignReasons[]) => {
        return Array.from(new Set(data.map(a => a.category)))
            .map(iddup => {
                return data.find(a => a.category === iddup && a.producttype !== 'Model');
            });
    };

    const duplicateCateModel = (data: RedesignReasons[]) => {
        return Array.from(new Set(data.map(a => a.category)))
            .map(iddup => {
                return data.find(a => a.category === iddup && a.producttype === 'Model');
            });
    };

    const changeDesignCategory = (event: React.ChangeEvent<HTMLInputElement>) => {

        if (event.target.checked === true) {
            setCategory(event.target.value);
            setOpenDesignReason(true);
        } else {
            setReason(reason.filter((allReasons) => allReasons.category !== event.target.value));
            const indexofCheck = categoryArray.indexOf(event.target.value);
            categoryArray.splice(indexofCheck !== -1 ? indexofCheck : 0, 1);
            setCategoryArray(categoryArray);
        }
    };
    const changeModelCategory = (event: React.ChangeEvent<HTMLInputElement>) => {

        if (event.target.checked === true) {
            setCategoryModel(event.target.value);
            setOpenModelReason(true);
        } else {
            setReasonModel(reasonModel.filter((allReasons) => allReasons.category !== event.target.value));
            const indexofCheck = categoryModelArray.indexOf(event.target.value);
            categoryModelArray.splice(indexofCheck !== -1 ? indexofCheck : 0, 1);
            setCategoryModelArray(categoryModelArray);
        }
    };

    const changeDesignReason = (event: React.ChangeEvent<HTMLInputElement>) => {

        const newArray: SubitReDesignCodes = {
            producttype: 'Design',
            category: category,
            reason: event.target.value
        };
        reason.push(newArray);
        setReason(reason);
        categoryArray.push(category);
        setCategoryArray(categoryArray);
        setOpenDesignReason(false);
    };
    const changeModelReason = (event: React.ChangeEvent<HTMLInputElement>) => {

        const newArrayModel: SubitReDesignCodes = {
            producttype: 'Model',
            category: categoryModel,
            reason: event.target.value
        };
        reasonModel.push(newArrayModel);
        setReasonModel(reasonModel);
        categoryModelArray.push(categoryModel);
        setCategoryModelArray(categoryModelArray);
        setOpenModelReason(false);
    };

    const handleClickOpenRe = () => {
        setMsg('');
        setPtype('Design');
        setPtypeModel('Model');
        setCategory('0');
        setCategoryModel('0');
        setOrderno(orderno);
        setuserName(userName);
        setTat('Next Day 7 AM');
        setOpenRe(true);
        setReasonModel([]);
        setReason([]);
        setCategoryModelArray([]);
        setCategoryArray([]);
    };
    const handleCloseRe = () => {
        setOpenRe(false);
    };
    const onCloseDesignReason = () => {
        setOpenDesignReason(false);
    };
    const onCloseModelReason = () => {
        setOpenModelReason(false);
    };
    const handleSubmitRe = () => {
        const columns = {
            columns: {
                customer: userName,
                caseno: orderno,
                tat: tat,
                destination: manufactType,
                msg: msg.replace(/[\n\r]+/g, ' ').replace(/\s{2,}/g, ' ').replace(/^\s+|\s+$/, '').replace(/\"/g, '')
            },
            reasons: reason.concat(reasonModel),
            id: 'rword'
        };
        setOpenRe(false);
        props.redesignRequest(columns);
    };

    const [openCom, setOpenCom] = React.useState(false);
    const handleClickOpenCom = () => {
        setOpenCom(true);
    };
    const handleCloseCom = () => {
        setOpenCom(false);
    };
    const handleSubmitCom = () => {
        const columns = {
            columns: {
                customer: userName,
                caseno: orderno,
                status: '10'
            },
            id: 'asnds'
        };
        setOpenCom(false);
        setAnchorEl(null);

        props.redesignRequest(columns);
    };

    const [openAppro, setOpenAppro] = React.useState(false);
    const handleClickOpenApp = (ordernumber: string) => {
        setMsgApp('');
        setOrderno(ordernumber);
        setOpenAppro(true);
    };
    const handleCloseApp = () => {
        setOpenAppro(false);
    };
    const handleSubmitApp = () => {
        setOpenAppro(false);
        const array = [{
            orderno: orderno,
            approval_reqd: '1',
            remarks: msgApp.replace(/[\n\r]+/g, ' ').replace(/\s{2,}/g, ' ').replace(/^\s+|\s+$/, '').replace(/\"/g, '')
        }];
        props.approvalRequired(array);
    };

    const msgAppChange = (msgValue: string) => {
        setMsgApp(msgValue);
    };

    const [page, setPage] = React.useState(0);
    const [size, setSize] = React.useState(10);
    const [selectedRowsArray, setSelectedRowsArray] = React.useState<RowDataManufactur[]>([]);

    const handleSelectAll = (tableData: RowDataManufactur[]) => {
        setSelectedRowsArray(tableData.slice(page * size, (page * size) + size));
    };
    const handleSelectOne = (tableData: RowDataManufactur) => {

        if (tableData.orderno) {
            setSelectedRowsArray((items: RowDataManufactur[]) => {
                if (items.find(_d => _d.orderno === tableData.orderno)?.orderno) {
                    return items.filter((item) => item.orderno !== tableData.orderno);
                }
                const newItems = items.concat([tableData]);
                return newItems;
            });
        }

    };

    const [downIndi, setDownIndi] = React.useState(false);
    const downloadFiletypes = ['STL', 'PTS', '3OX'];
    const [openDownload, setOpenDownload] = React.useState(false);
    const [fileTypes, setFileTypes] = React.useState<string[]>([]);
    const [downloadType, setDownloadType] = React.useState('multiple');

    const openDownloadDialog = (rowdata: RowDataManufactur[] | RowDataManufactur, type: String) => {
        if (type === 'zip' && selectedRowsArray.length === 1) {
            props.onBulkDownload(selectedRowsArray);
        } else {
            if (type === 'zip') { setDownIndi(true); setDownloadType('multiple'); } else { setDownIndi(false); }
            setFileTypes([]);
            setOpenDownload(true);
        }
    };
    const filetypeChange = (event: React.ChangeEvent<HTMLInputElement>) => {

        if (event.target.checked === true) {
            fileTypes.push(event.target.value);
            const tempType = fileTypes.filter((v, i) => fileTypes.indexOf(v) === i);
            setFileTypes(tempType);
        } else {
            setFileTypes(fileTypes.filter((allTypes) => allTypes !== event.target.value));
        }
    };

    const closeDownloadDialog = () => {
        setOpenDownload(false);
    };
    const submitStlDownload = () => {
        setOpenDownload(false);
        props.onBulkDownloadStl(selectedRowsArray, fileTypes.toString());
    };
    const submitZipDownload = () => {
        setOpenDownload(false);
        if (downloadType === 'single') {
            props.onBulkDownload(selectedRowsArray);
        } else {
            props.onBulkDownloadIndividual(selectedRowsArray);
        }
    };

    const emptyData = {
        rowno: '',
        orderno: '',
        orderdate: '',
        fname: '',
        fpath: '',
        filesize: '',
        feedback: '',
        vfiles: '',
        material: '',
        servicename: '',
        designtype: '',
        tat: '',
        msg: '',
        nounits: '',
        status: '',
        completedon: '',
        final_scan_url: '',
        customerstatus: '',
        mfrstatus: '',
        fdownload: '',
        qc_required: '',
        labname: '',
        casenotes: '',
        customer: '',
        batchno: '',
        iterono: '',
        holdreason: ''
    };

    const [openViewManufact, setOpenViewManufact] = React.useState(false);
    const [rowDataPreview, setrowDataPreview] = React.useState<RowDataManufactur>(emptyData);

    const openPreviewPopup = (data: RowDataManufactur) => {
        setrowDataPreview(data);
        props.getPreviewData(data.orderno);
        setOpenViewManufact(true);
    };

    const closePreviewPopup = () => {
        setOpenViewManufact(false);
        setrowDataPreview(emptyData);
        props.resetPreviewData();
    };

    let fileTypesView: string[] = ['Initial Scan', 'Quality Image', 'Others'];

    switch (rowDataPreview.status) {
        case '10':
            fileTypesView = ['Initial Scan', 'STL File', 'PTS/3OX Files', 'Quality Image', 'Final Scan', 'Others'];
            break;
        case '14':
            if ((props.userDetails.ugroup === 'Manufacturer' || props.userDetails.ugroup === 'EDDL')) {
                fileTypesView = ['Initial Scan', 'STL File', 'PTS/3OX Files', 'Quality Image', 'Final Scan', 'Others'];
            } else if (props.userDetails.ugroup === 'Lab') {
                fileTypesView = ['Initial Scan', 'STL File', 'PTS/3OX Files', 'Quality Image', 'Final Scan', 'Others'];
            }
            break;
        default:
            fileTypesView = ['Initial Scan', 'Quality Image', 'Others'];
    }

    const fileRender1 = (fileType: string) => {
        if ((fileType !== 'PTS/3OX Files' && fileType !== 'STL File')) {
            const filteredFiles = props.previewOrderData.getFileData.filter(uniquefiles => uniquefiles.filetype === fileType);
            // // ==> console.error(filteredFiles);
            if (filteredFiles.length > 0) {
                return filteredFiles.map((r, index) => (
                    <Typography
                        key={`id_${index}`}
                        onClick={() => props.downloadFile(r.filename.replace(`/${r.filename.split('/').reverse()[0]}`, ''), r.filename.split('/').reverse()[0], fileType)}
                        className={classes.fileHover}
                        variant={openViewManufact ? 'overline' : 'body1'}
                    >
                        {r.filename.split('/').reverse()[0]}
                    </Typography>
                )
                );
            }
            return 'No Data';
        } else if (fileType === 'PTS/3OX Files') {
            const filteredFiles = props.previewOrderData.getFileData.filter(uniquefiles => (uniquefiles.filename.split('.').reverse()[0] === 'pts' || uniquefiles.filename.split('.').reverse()[0] === '3ox'));

            if (filteredFiles.length > 0) {
                return filteredFiles.map((r, index) => (
                    <Typography
                        key={`id_${index}`}
                        onClick={() => props.downloadFile(r.filename.replace(`/${r.filename.split('/').reverse()[0]}`, ''), r.filename.split('/').reverse()[0], fileType)}
                        className={classes.fileHover}
                        variant={openViewManufact ? 'overline' : 'body1'}
                    >
                        {r.filename.split('/').reverse()[0]}
                    </Typography>
                )
                );
            }
            return 'No Data';
        } else if (fileType === 'STL File') {
            const filteredFiles = props.previewOrderData.getFileData.filter(uniquefiles => (uniquefiles.filetype === fileType && uniquefiles.filename.split('.').reverse()[0] === 'stl'));

            if (filteredFiles.length > 0) {
                return filteredFiles.map((r, index) => (
                    <Typography
                        key={`id_${index}`}
                        onClick={() => props.downloadFile(r.filename.replace(`/${r.filename.split('/').reverse()[0]}`, ''), r.filename.split('/').reverse()[0], fileType)}
                        className={classes.fileHover}
                        variant={openViewManufact ? 'overline' : 'body1'}
                    >
                        {r.filename.split('/').reverse()[0]}
                    </Typography>
                )
                );
            }
            return 'No Data';
        }
        return 'No Data';
    };

    const chatBubbles = Array.isArray(props.previewOrderData.getUserMessage) && props.previewOrderData.getUserMessage.map((obj, i) => (
        <ScrollToBottom>
            <div>
                {rowDataPreview.customer === obj.mfrom ?
                    <div className={classes.right}>
                        <div key={i++} className={classes.bubble}>
                            <img src="/assets/lab.png" className={classes.imageHeight} />
                            <div className={classes.mfrom}>{obj.mfrom}</div>
                        </div>
                        <div key={i++} className={classes.message}>
                            <div>{obj.message}</div>
                        </div>
                        <div key={i++} className={classes.date}>
                            <div>{obj.mdate}</div>
                        </div>
                        {obj.attachfilename !== '' ?
                            <div onClick={() => props.msgAtt(obj.attachfilename)} key={i++} className={classes.attachment}>
                                <div>{obj.attachfilename.split('/').reverse()[0]}</div>
                            </div>
                            :
                            null
                        }
                    </div>
                    : <div className={classes.left}>
                        <div key={i++} className={classes.bubbleReciver}>
                            <img src="/assets/designer.png" className={classes.imageHeight} />
                            <div className={classes.mto}>{obj.mfrom}</div>
                        </div>
                        <div key={i++} className={classes.message}>
                            <div>{obj.message}</div>
                        </div>
                        <div key={i++} className={classes.date}>
                            <div>{obj.mdate}</div>
                        </div>
                        {obj.attachfilename !== '' ?
                            <div onClick={() => props.msgAtt(obj.attachfilename)} key={i++} className={classes.date}>
                                <div>{obj.attachfilename.split('/').reverse()[0]}</div>
                            </div>
                            :
                            null
                        }
                    </div>
                }
            </div>
        </ScrollToBottom>
    ));

    const [openStlview, setOpenStlview] = React.useState(false);
    const [selectedstls, setSelectedstls] = React.useState<GetFileData[]>([]);
    const [selectedstlsString, setSelectedstlsString] = React.useState<string[]>([]);
    const [allStls, setallStls] = React.useState<GetFileData[]>([]);

    const openStlSelect = (files: GetFileData[]) => {
        setallStls(files.filter(r => (r.filetype === 'STL File' && r.filename.split('.').reverse()[0] === 'stl')));
        setOpenStlview(true);
        setSelectedstls([]);
        setSelectedstlsString([]);
    };

    const closeStlSelect = () => {
        setOpenStlview(false);
        setSelectedstls([]);
        setSelectedstlsString([]);
        setallStls([]);
    };

    const onSelectstl = (event: React.ChangeEvent<HTMLInputElement>) => {

        const selectedOld = selectedstls;
        const selectedStringOld = selectedstlsString;

        if (event.target.checked === true) {
            const selected = allStls.filter((stls) => stls.filename === event.target.value);
            selectedOld.push(selected[0]);
            setSelectedstls(selectedOld.filter((stl) => stl.filename !== ''));

            selectedStringOld.push(event.target.value);
            setSelectedstlsString(selectedStringOld.filter((stl) => stl !== ''));
        } else {
            setSelectedstls(selectedstls.filter((stls) => stls.filename !== event.target.value));

            const indexofCheck = selectedstlsString.indexOf(event.target.value);
            selectedstlsString.splice(indexofCheck !== -1 ? indexofCheck : 0, 1);
            setSelectedstlsString(selectedstlsString);
        }
    };

    const submitStlSelect = () => {
        props.goStlViewer(selectedstls);
        setOpenStlview(false);
        setSelectedstls([]);
        setSelectedstlsString([]);
        setallStls([]);
    };

    const [state] = React.useState<TableStateDate>({
        columns: [
            {
                title: 'Date',
                field: 'orderdate',
                filtering: false,
                cellStyle: {
                    fontSize: '12px',
                    padding: '0px',
                    textAlign: 'center'
                }
            },
            {
                title: 'Batch ID',
                field: 'batchno',
                filtering: false,
                cellStyle: {
                    padding: '0px',
                    fontSize: '12px',
                    textAlign: 'center'
                }
            },
            {
                title: 'Itero No',
                field: 'iterono',
                filtering: false,
                render: rowData => (
                    <div>
                        {
                            rowData.iterono !== '' ? rowData.iterono : '-'
                        }
                    </div>
                ),
                cellStyle: {
                    fontSize: '12px',
                    padding: '0px',
                    textAlign: 'center'
                }
            },
            {
                title: 'Case No',
                field: 'orderno',
                filtering: false,
                render: rowData => (
                    <div>
                        {
                            rowData.qc_required === '0' ?
                                rowData.orderno
                                :
                                rowData.qc_required === '1' ?
                                    <div>
                                        {rowData.orderno}
                                        <div className={classes.qcreq}>
                                            QC Required
                                        </div>
                                    </div>
                                    :
                                    rowData.qc_required === '2' ?
                                        <div>
                                            {rowData.orderno}
                                            <div className={classes.qcreq} onClick={() => handleClickOpenApp(rowData.orderno)} style={{ color: 'green', cursor: 'pointer' }}>
                                                Approve
                                            </div>
                                        </div>
                                        :
                                        rowData.orderno
                        }
                    </div>
                ),
                cellStyle: {
                    fontSize: '12px',
                    padding: '0px',
                    textAlign: 'center'
                }
            },
            //  {
            //     title: 'Booking ID',
            //     field: 'refno',
            //     filtering: false,
            //     cellStyle: {
            //         fontSize: '12px',
            //         padding: '0px',
            //         textAlign: 'center'
            //     }
            // },
            {
                title: 'Status',
                field: 'mfrstatus',
                filtering: false,
                cellStyle: {
                    fontSize: '12px',
                    padding: '0px',
                    textAlign: 'center'
                }
            },
            {
                title: 'Hold Reason',
                field: 'holdreason',
                filtering: false,
                render: rowData => (
                    <div>
                        {
                            rowData.holdreason !== '' ? rowData.holdreason : '-'
                        }
                    </div>
                ),
                cellStyle: {
                    fontSize: '12px',
                    padding: '0px',
                    textAlign: 'center'
                }
            },
            {
                title: 'Action',
                field: 'fdownload',
                export: false,
                // cellStyle: {
                //   backgroundColor: '#039be5',
                //   color: '#FFF'
                // },
                render: rowData => (
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <Tooltip title="Preview" placement="top">
                            <IconButton
                                aria-label="view"
                                onClick={() => {
                                    openPreviewPopup(rowData);
                                }}
                            >
                                <TrackChangesTwoToneIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Update" placement="top">
                            <IconButton
                                aria-label="view"
                                onClick={(event: React.MouseEvent<HTMLButtonElement>) => popoverClick(event, rowData)}
                                disabled={rowData.status === '14' ? false : true}
                            >
                                <RedoIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Support" placement="top">
                            <IconButton
                                aria-label="support"
                                onClick={(event: React.MouseEvent<HTMLButtonElement>) => props.supportPage(rowData.orderno)}
                            >
                                <ThumbsUpDownRoundedIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="View" placement="top">
                            <IconButton aria-label="view" onClick={() => props.onRowClick((JSON.parse(JSON.stringify(rowData)).orderno), (JSON.parse(JSON.stringify(rowData)).ds_ordersid))}>
                                <VisibilityIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                        {
                            (parseInt(rowData.msg, 10) && parseInt(rowData.msg, 10) > 0) ?
                                <IconButton aria-label="msg" disabled>
                                    <Badge color="secondary" variant="dot">
                                        <MailOutlineIcon fontSize="small" />
                                    </Badge>
                                </IconButton>
                                : null
                        }
                        {
                            rowData.vfiles !== '' ?
                                <Tooltip title="Video" placement="top">
                                    <IconButton
                                        color="primary"
                                        onClick={() => props.openVideoPlayerURL(rowData.vfiles.split(','), rowData.fpath)}
                                        aria-label="view video"
                                    >
                                        <PlayCircleFilledTwoToneIcon fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                                : null
                        }
                    </div>
                ),
                cellStyle: {
                    padding: '0px'
                }
            }
        ],
        data: props.mfilteredOrderData
    });

    const tableHeaders = [
        { label: 'Date', key: 'orderdate' },
        { label: 'Batch ID', key: 'batchno' },
        { label: 'Itero No', key: 'iterono' },
        { label: 'Case No', key: 'orderno' },
        // { label: 'Booking ID', key: 'refno' },
        { label: 'Status', key: 'mfrstatus' },
        { label: 'Hold Reason', key: 'holdreason' }
    ];

    // Add these new state variables in the component
    const [selectedFailedFiles, setSelectedFailedFiles] = React.useState<Array<{ fname: string; orderno: string }>>([]);

    // Add these handler functions
    const handleFailedFileCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>, file: { fname: string; orderno: string }) => {
        if (event.target.checked) {
            setSelectedFailedFiles([...selectedFailedFiles, file]);
        } else {
            setSelectedFailedFiles(selectedFailedFiles.filter(item =>
                !(item.fname === file.fname && item.orderno === file.orderno)
            ));
        }
    };

    const handleSelectAllFailedFiles = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.checked) {
            setSelectedFailedFiles([...props.failedFiles]);
        } else {
            setSelectedFailedFiles([]);
        }
    };
    const [retryCountMap, setRetryCountMap] = React.useState<Record<string, number>>({});
    React.useEffect(
            () => {
            if (props.showFailedFilesDialog) {
                // Initialize retry counts for any new files
                const newRetryCountMap = {...retryCountMap};
                props.failedFiles.forEach(file => {
                const fileKey = `${file.orderno}-${file.fname}`;
                if (newRetryCountMap[fileKey] === undefined) {
                    newRetryCountMap[fileKey] = 0;
                }
                });
                setRetryCountMap(newRetryCountMap);
                
                // Automatically select all files that haven't exceeded retry limit
                const availableFiles = props.failedFiles.filter(file => {
                const fileKey = `${file.orderno}-${file.fname}`;
                return (newRetryCountMap[fileKey] || 0) < 3;
                });
                
                // Set the selected files
                setSelectedFailedFiles(availableFiles);
            }
            },
            [props.showFailedFilesDialog, props.failedFiles]
        );
    
    // Modify the handleRetryDownload function to track retry counts
    const handleRetryDownload = () => {
        if (selectedFailedFiles.length > 0) {
            // Update retry counts for selected files
            const updatedRetryCountMap = {...retryCountMap};
            selectedFailedFiles.forEach(file => {
                const fileKey = `${file.orderno}-${file.fname}`;
                updatedRetryCountMap[fileKey] = (updatedRetryCountMap[fileKey] || 0) + 1;
            });
            setRetryCountMap(updatedRetryCountMap);
            
            // Create filtered list with only files that haven't exceeded retry limit
            const filesToDownload = props.mfilteredOrderData.filter(item =>
                selectedFailedFiles.some(file => {
                    const fileKey = `${file.orderno}-${file.fname}`;
                    const retryCount = updatedRetryCountMap[fileKey] || 0;
                    return file.fname === item.fname && file.orderno === item.orderno && retryCount <= 3;
                })
            );
            props.closeFailedFilesDialog();            

            if (filesToDownload.length > 0) {
                if (downloadType === 'single') {
                props.onBulkDownload(filesToDownload, true); 
                } else {
                props.onBulkDownloadIndividual(filesToDownload, true); 
                }
            }
        }
    };

    // Helper function to check if a file has exceeded retry limit
    const hasExceededRetryLimit = (file: { fname: string; orderno: string }): boolean => {
        const fileKey = `${file.orderno}-${file.fname}`;
        return (retryCountMap[fileKey] || 0) >= 3;
    };

    // Helper function to get number of retries for a file
    const getRetryCount = (file: { fname: string; orderno: string }): number => {
        const fileKey = `${file.orderno}-${file.fname}`;
        return retryCountMap[fileKey] || 0;
    };
    const stfFailedFiles = props.failedFiles.filter(file => file.fileType === 'STL');

    return (
        <div className={classes.root}>
            <Grid container justify="center" alignItems="center" >
                <Grid item xs={12} sm={12} md={12}>
                    <div>
                        <Tooltip title="Refresh" placement="top" arrow>
                            <Fab color="primary" aria-label="add" style={{ height: '40px', width: '40px', float: 'left', margin: '12px', zIndex: 100 }} onClick={props.reload}>
                                <AutorenewIcon />
                            </Fab>
                        </Tooltip>
                        <Tooltip title="Export" placement="top" arrow>
                            <Button
                                id="Export"
                                aria-controls="customized-menu"
                                aria-haspopup="true"
                                variant="contained"
                                color="primary"
                                className={classes.buttonSend}
                            >
                                <CSVLink
                                    data={props.mfiltersdataExport}
                                    // enclosingCharacter={``}
                                    headers={tableHeaders}
                                    filename={'Production Status Report.csv'}
                                    className={classes.exportButton}
                                // target="_blank"
                                >
                                    <FileCopyIcon className={classes.exportIcon} />
                                </CSVLink>
                            </Button>
                        </Tooltip>
                        <Popover
                            id={id}
                            open={open}
                            anchorEl={anchorEl}
                            onClose={popoverClose}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'center',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'center',
                            }}
                        >
                            <div>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    className={classes.button}
                                    // startIcon={<DeleteIcon />}
                                    onClick={handleClickOpenCom}
                                >
                                    Complete
                                </Button>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    className={classes.button}
                                    // endIcon={<RestoreIcon />}
                                    onClick={handleClickOpenRe}
                                >
                                    Re-Design
                                </Button>
                            </div>
                        </Popover>
                        {props.isDownloading === true ? <CircularProgress className={classes.buttonSend} /> : null}
                        <Dialog
                            // open={props.showFailedFilesDialog && props.failedFiles.length > 0}
                            open={props.showFailedFilesDialog && props.failedFiles.length > 0 && stfFailedFiles.length === 0}
                            onClose={props.closeFailedFilesDialog}
                            aria-labelledby="failed-files-dialog-title"
                            fullWidth
                            maxWidth="sm"
                        >
                            <DialogTitle id="failed-files-dialog-title">
                                <Typography style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                    Failed Downloads
                                </Typography>
                            </DialogTitle>
                            <DialogContent dividers>
                                {props.failedFiles && props.failedFiles.length > 0 && (
                                    <div className={classes.failedFilesContainer}>
                                        <Box style={{ display: 'flex', justifyContent: 'space-between' }}>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={selectedFailedFiles.length === props.failedFiles.length}
                                                        onChange={handleSelectAllFailedFiles}
                                                        color="primary"
                                                    />
                                                }
                                                label="Select All"
                                            />
                                            <Typography variant="subtitle1" style={{ fontWeight: 'bold', color: 'red' }}>
                                                Total: {props.failedFiles?.length}
                                            </Typography>
                                        </Box>
                                        <TableContainer component={Paper} className={classes.tableContainer}>
                                            <Table aria-label="failed files table" size="small">
                                                <TableHead style={{ backgroundColor: '#bdbdbd', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                    <TableRow>
                                                        <TableCell padding="checkbox">Select</TableCell>
                                                        <TableCell>S.No</TableCell>
                                                        <TableCell>Order No</TableCell>
                                                        <TableCell>File Name</TableCell>
                                                        <TableCell>Retry Count</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {props.failedFiles.map((file, index) => {
                                                        const exceededLimit = hasExceededRetryLimit(file);
                                                        const retryCount = getRetryCount(file);

                                                        return (
                                                            <TableRow key={index}>
                                                                <TableCell padding="checkbox">
                                                                    <Checkbox
                                                                        checked={selectedFailedFiles.some(item => item.fname === file.fname && item.orderno === file.orderno)}
                                                                        onChange={(event) => handleFailedFileCheckboxChange(event, file)}
                                                                        color="primary"
                                                                        disabled={exceededLimit}
                                                                    />
                                                                </TableCell>
                                                                <TableCell>{index + 1}</TableCell>
                                                                <TableCell>{file.orderno}</TableCell>
                                                                <TableCell>{file.fname}</TableCell>
                                                                <TableCell>
                                                                    {retryCount}/3
                                                                    {exceededLimit && (
                                                                        <Typography variant="caption" style={{ color: 'red', display: 'block', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                                            Max retries exceeded
                                                                        </Typography>
                                                                    )}
                                                                </TableCell>
                                                            </TableRow>
                                                        );
                                                    })}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </div>
                                )}
                            </DialogContent>
                            <DialogActions>
                                <Button
                                    onClick={handleRetryDownload}
                                    style={{
                                        backgroundColor: selectedFailedFiles.some(file => !hasExceededRetryLimit(file))
                                            ? '#1976d2' : '#f44336',
                                        color: 'white'
                                    }}
                                    variant="contained"
                                    disabled={selectedFailedFiles.length === 0 || selectedFailedFiles.every(file => hasExceededRetryLimit(file))}
                                >
                                    Retry Download
                                </Button>
                                <Button onClick={props.closeFailedFilesDialog} color="primary" variant="contained">
                                    Close
                                </Button>
                            </DialogActions>
                        </Dialog>

                        <Dialog
                            open={props.showFailedFilesDialog && stfFailedFiles.length > 0}  // Show dialog only if there are STL files
                            onClose={props.closeFailedFilesDialog}
                            aria-labelledby="failed-files-dialog-title"
                            fullWidth
                            maxWidth="sm"
                        >
                            <DialogTitle id="failed-files-dialog-title">
                                <Typography style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                    STL Files - Failed Downloads
                                </Typography>
                            </DialogTitle>
                            <DialogContent dividers>
                                {stfFailedFiles && stfFailedFiles.length > 0 && (
                                    <div className={classes.failedFilesContainer}>
                                        {/* <Box style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                                            <Typography variant="subtitle1" style={{ fontWeight: 'bold', color: 'green' }}>
                                                STL files available for: {selectedRowsArray.length} orders
                                            </Typography>
                                        </Box>

                                        <Box style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                                            <Typography variant="subtitle1" style={{ fontWeight: 'bold', color: 'red' }}>
                                                STL files not available for: {stfFailedFiles.length} orders
                                            </Typography>
                                        </Box> */}
                                        <Box 
                                                style={{ 
                                                    border: '1px solid #e0e0e0', 
                                                    borderRadius: '4px', 
                                                    padding: '12px', 
                                                    marginBottom: '8px' 
                                                }}
                                        >
                                                <Box style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '2px' }}>
                                                    <Typography variant="subtitle1" color="textSecondary">
                                                        {/* STL files available for: {caseCount ?? 0} orders */}
                                                        Below files are not available. Please contact support team
                                                    </Typography>
                                                    {/* <Typography variant="subtitle1" style={{ fontWeight: 'bold' }}>
                                                        Total: {stfFailedFiles.length}
                                                    </Typography> */}
                                                </Box>
                                                
                                                {/* <Typography variant="subtitle1" color="textSecondary">
                                                    STL files not available for: {selectedRowsArray.length - (caseCount ?? 0)} orders
                                                </Typography> */}
                                        </Box>
                                        <TableContainer component={Paper} className={classes.tableContainer}>
                                            <Table aria-label="failed files table" size="small">
                                                <TableHead style={{ backgroundColor: '#bdbdbd', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                    <TableRow>
                                                        <TableCell>S.No</TableCell>
                                                        <TableCell>Order No</TableCell>
                                                        <TableCell>File Name</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {stfFailedFiles.map((file, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell>{index + 1}</TableCell>
                                                            <TableCell>{file.orderno}</TableCell>
                                                            <TableCell>{file.fname}</TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </div>
                                )}
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={props.closeFailedFilesDialog} color="primary" variant="contained">
                                    Close
                                </Button>
                            </DialogActions>
                        </Dialog>
                                                
                        <Dialog
                            open={openRe}
                            aria-labelledby="Dialog-Order-Redesign"
                            fullWidth={fullWidthReason}
                            maxWidth={maxWidthReason}
                        >
                            <DialogTitle id="form-dialog-title">Re-Design Request on Order No : {orderno}</DialogTitle>
                            <DialogContent dividers>
                                <Grid container spacing={1}>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <CssTextFieldRedesign
                                            fullWidth
                                            disabled
                                            size="small"
                                            onChange={(event) => setPtype(event.target.value as string)}
                                            value={ptype}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container>
                                    {
                                        duplicateCateDesign(props.redesignReasons).map((cate, indexRe1) => (
                                            typeof (cate) === 'object' && cate!.producttype !== 'Model' ?
                                                <Grid item xs={12} sm={6} md={3}>
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                id={`category${indexRe1}`}
                                                                checked={categoryArray.indexOf(cate!.category) !== -1 ? true : false}
                                                                value={cate!.category}
                                                                onChange={changeDesignCategory}
                                                                name="category"
                                                            />
                                                        }
                                                        label={<Typography variant="caption">{cate!.category}</Typography>}
                                                    />
                                                </Grid>
                                                : null
                                        ))
                                    }

                                </Grid>
                                <hr style={{ margin: '10px 0' }} />
                                <Grid container spacing={1}>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <CssTextFieldRedesign
                                            fullWidth
                                            disabled
                                            size="small"
                                            onChange={(event) => setPtypeModel(event.target.value as string)}
                                            value={ptypeModel}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container>
                                    {
                                        duplicateCateModel(props.redesignReasons).map((cateModel, indexRe1) => (
                                            typeof (cateModel) === 'object' && cateModel!.producttype === 'Model' ?
                                                <Grid item xs={12} sm={6} md={3}>
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                id={`categoryModel${indexRe1}`}
                                                                checked={categoryModelArray.indexOf(cateModel!.category) !== -1 ? true : false}
                                                                value={cateModel!.category}
                                                                onChange={changeModelCategory}
                                                                name="category"
                                                            />
                                                        }
                                                        label={<Typography variant="caption">{cateModel!.category}</Typography>}
                                                    />
                                                </Grid>
                                                : null
                                        ))
                                    }
                                </Grid>
                                <hr style={{ margin: '10px 0' }} />
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <FormControl variant="outlined" size="small" className={classes.forms}>
                                            <Select
                                                id="demo-simple-select-outlined-6"
                                                defaultValue="Next Day 7 AM"
                                                onChange={(event) => setTat(event.target.value as string)}
                                                value={tat}
                                            >
                                                {Array.isArray(props.orderDataTat) && props.orderDataTat.length > 0 && props.orderDataTat.map((tatime, index1) => (
                                                    <MenuItem id={tatime.rowno} value={tatime.tattype}>{tatime.tattype}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <FormControl variant="outlined" size="small" className={classes.forms}>
                                            <Select
                                                labelId="demo-simple-select-outlined-label-red1"
                                                id="demo-simple-select-outlined-red1"
                                                required
                                                fullWidth
                                                onChange={(event) => saveManufactType(event.target.value as string)}
                                                value={manufactType}
                                            >
                                                <MenuItem disabled value="">
                                                    <em>Destination</em>
                                                </MenuItem>
                                                <MenuItem value="In-House">
                                                    In-House
                                                </MenuItem>
                                                {Array.isArray(props.orderDataManufacturer) && props.orderDataManufacturer.length > 0 && props.orderDataManufacturer.map((manufactTypes) => (
                                                    <MenuItem id={manufactTypes.rowno} value={manufactTypes.dest}>{manufactTypes.dest}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={4}>
                                        <FormControl fullWidth variant="outlined" size="small">
                                            <TextField
                                                variant="outlined"
                                                label="Remarks"
                                                multiline
                                                // rows={3}
                                                rowsMax={5}
                                                size="small"
                                                onChange={(event) => setMsg(event.target.value as string)}
                                                value={msg}
                                                required
                                            />
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            </DialogContent>
                            <DialogActions style={{ justifyContent: 'space-between' }}>
                                <Typography variant="caption">
                                    *Please select Reason, TAT, Destination and enter Remarks to submit Re-Design.
                                </Typography>
                                <div className={classes.modal}>
                                    <Button size="small" onClick={handleCloseRe} color="secondary">
                                        Cancel
                                    </Button>
                                    <Button
                                        size="small"
                                        disabled={(msg === '' || (reason.length === 0 && reasonModel.length === 0)) ? true : false}
                                        onClick={handleSubmitRe}
                                        color="primary"
                                    >
                                        Re-Design
                                    </Button>
                                </div>
                            </DialogActions>
                        </Dialog>
                        <Dialog
                            open={openDesignReason}
                            onClose={onCloseDesignReason}
                        >
                            <DialogTitle id="form-dialog-title-reasons">{category} :</DialogTitle>
                            <DialogContent dividers>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={12} md={12}>
                                        <div className={classes.reasonBox}>
                                            <FormControl variant="outlined" fullWidth className={classes.forms}>
                                                <Select
                                                    id="demo-simple-select-outlined-2"
                                                    defaultValue="0"
                                                    fullWidth
                                                    onChange={changeDesignReason}
                                                    value="0"
                                                >
                                                    <MenuItem value="0" disabled>Select Reason</MenuItem>
                                                    {Array.isArray(props.redesignReasons)
                                                        && props.redesignReasons.length > 0
                                                        && props.redesignReasons.map((reasonsRe, indexRe1) => (
                                                            reasonsRe.producttype !== 'Model' && reasonsRe.category === category ?
                                                                <MenuItem id={reasonsRe.rowno} value={reasonsRe.code}>{reasonsRe.codedesc}</MenuItem>
                                                                :
                                                                null
                                                        ))}
                                                </Select>
                                            </FormControl>
                                        </div>
                                    </Grid>
                                </Grid>
                            </DialogContent>
                        </Dialog>
                        <Dialog
                            open={openModelReason}
                            onClose={onCloseModelReason}
                        >
                            <DialogTitle id="form-dialog-title-reasons">{categoryModel} :</DialogTitle>
                            <DialogContent dividers>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={12} md={12}>
                                        <div className={classes.reasonBox}>
                                            <FormControl variant="outlined" fullWidth className={classes.forms}>
                                                <Select
                                                    id="demo-simple-select-outlined-5"
                                                    defaultValue="0"
                                                    fullWidth
                                                    onChange={changeModelReason}
                                                    value="0"
                                                >
                                                    <MenuItem value="0" disabled>Select Reason (Model)</MenuItem>
                                                    {Array.isArray(props.redesignReasons)
                                                        && props.redesignReasons.length > 0
                                                        && props.redesignReasons.map((reasonsModl, indexRe1) => (
                                                            reasonsModl.producttype === 'Model' && reasonsModl.category === categoryModel ?
                                                                <MenuItem id={reasonsModl.rowno} value={reasonsModl.code}>{reasonsModl.codedesc}</MenuItem>
                                                                :
                                                                null
                                                        ))}
                                                </Select>
                                            </FormControl>
                                        </div>
                                    </Grid>
                                </Grid>
                            </DialogContent>
                        </Dialog>
                        <Dialog
                            open={openCom}
                            onClose={handleCloseCom}
                            aria-labelledby="Dialog-Order-Redesign"
                            fullWidth={fullWidth}
                            maxWidth={maxWidth}
                        >
                            <DialogTitle id="form-dialog-title">Complete the Order : {orderno} ?</DialogTitle>
                            <DialogActions>
                                <Button size="small" onClick={handleCloseCom} color="secondary">
                                    Cancel
                                </Button>
                                <Button size="small" onClick={handleSubmitCom} color="primary">
                                    Complete
                                </Button>
                            </DialogActions>
                        </Dialog>
                        <Dialog
                            open={openAppro}
                            onClose={handleCloseApp}
                            aria-labelledby="Dialog-Order-Redesign"
                            fullWidth={fullWidth}
                            maxWidth={maxWidth}
                        >
                            <DialogTitle id="form-dialog-title">Approve Design on Order No : {orderno}</DialogTitle>
                            <DialogContent dividers>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={12} md={12}>
                                        <FormControl fullWidth variant="outlined" size="small">
                                            <TextField
                                                variant="outlined"
                                                label="Remarks"
                                                multiline
                                                rows={3}
                                                rowsMax={5}
                                                size="small"
                                                onChange={(event) => msgAppChange(event.target.value as string)}
                                                value={msgApp}
                                            />
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            </DialogContent>
                            <DialogActions>
                                <Button size="small" onClick={handleCloseApp} color="secondary">
                                    Cancel
                                </Button>
                                <Button size="small" onClick={handleSubmitApp} color="primary">
                                    Approve
                                </Button>
                            </DialogActions>
                        </Dialog>
                        <Dialog
                            open={openDownload}
                            onClose={closeDownloadDialog}
                            aria-labelledby="Dialog-Order-Redesign"
                            fullWidth
                            maxWidth="sm"
                        // maxWidth={!downIndi ? maxWidthDownload : 'md'}
                        >
                            <DialogTitle id="form-dialog-title">{!downIndi ? 'What to download?' : 'Download As'}</DialogTitle>
                            {!downIndi ?
                                <DialogContent dividers>
                                    <Grid container spacing={2}>
                                        {
                                            downloadFiletypes.map((typeFile, indexRe1) => (
                                                <Grid item key={indexRe1} xs={6} sm={4} md={4}>
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                id={`filetype${indexRe1}`}
                                                                checked={fileTypes.indexOf(typeFile) > -1}
                                                                value={typeFile}
                                                                onChange={filetypeChange}
                                                                name="Filetype"
                                                            />
                                                        }
                                                        label={typeFile}
                                                    />
                                                </Grid>
                                            ))
                                        }
                                    </Grid>
                                </DialogContent>
                                // : <DialogContent dividers>
                                //     <Grid container spacing={2}>
                                //         <RadioGroup aria-label="down-type" name="download-type" value={downloadType} onChange={(e) => setDownloadType(e.target.value)}>
                                //             <FormControlLabel value="single" control={<Radio color="secondary" />} label="Single Compressed File" />
                                //             <FormControlLabel value="multiple" control={<Radio color="secondary" />} label="Individual Files" />
                                //         </RadioGroup>
                                //     </Grid>
                                // </DialogContent>
                                : <DialogContent dividers>
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                    <RadioGroup 
                                        aria-label="down-type" 
                                        name="download-type" 
                                        value={downloadType} 
                                        onChange={(e) => setDownloadType(e.target.value)}
                                    >
                                        {selectedRowsArray && selectedRowsArray.length <= 10 && ( 
                                        <FormControlLabel value="single" control={<Radio color="secondary" />} label="Single Compressed File" /> 
                                        )}
                                        <FormControlLabel value="multiple" control={<Radio color="secondary" />} label="Individual Files" />
                                    </RadioGroup>
                                    </Grid>
                                    {selectedRowsArray && selectedRowsArray.length > 0 && (
                                        <Grid item xs={12}>
                                        <Box 
                                            p={2} 
                                            mt={1}
                                            border={1} 
                                            borderColor="divider" 
                                            borderRadius="borderRadius" 
                                            bgcolor="background.paper"
                                        >
                                            <Typography variant="subtitle2" gutterBottom>
                                            Selected Files: {selectedRowsArray.length}
                                            </Typography>
                                            
                                            {/* <Typography variant="body2" color="textSecondary">
                                            Total Size: {calculateTotalFileSize(selectedRowsArray)}
                                            </Typography> */}
                                            {selectedRowsArray.length <= 5 ? (
                                            <Typography variant="body2" color="textSecondary">
                                                Estimated download time: 3 - 5 Mins (approx)
                                            </Typography>
                                            ) : selectedRowsArray.length > 5 && selectedRowsArray.length <= 25 ? (
                                            <Typography variant="body2" color="textSecondary">
                                                Estimated download time: 8 - 10 Mins (approx)
                                            </Typography>
                                            ) : selectedRowsArray.length > 25 && selectedRowsArray.length <= 50 ? (
                                            <Typography variant="body2" color="textSecondary">
                                                Estimated download time: 15 - 18 Mins (approx)
                                            </Typography>
                                            ) : (
                                            <Typography variant="body2" color="textSecondary">
                                                Estimated download time: 20 - 25 Mins (approx)
                                            </Typography>
                                            )}
                                        </Box>
                                        </Grid>
                                    )}
                                </Grid>
                                </DialogContent>
                            }
                            <DialogActions>
                                {downloadType === 'single' && downIndi && <Typography variant="caption" >
                                    *Note: If selected file size exceeding 1 GB might not download properly, consider downloading as Individual files.
                                </Typography>}
                                <Button size="small" onClick={closeDownloadDialog} color="secondary">
                                    Cancel
                                </Button>
                                {!downIndi && <Button size="small" onClick={submitStlDownload} color="primary">
                                    Download
                                </Button>}
                                {downIndi && <Button size="small" onClick={() => submitZipDownload()} color="primary">
                                    OK
                                </Button>}
                            </DialogActions>
                        </Dialog>
                    </div>
                    <MaterialTable
                        icons={tableIcons}
                        title="Production Status"
                        columns={state.columns}
                        data={props.mfilteredOrderData}
                        localization={{
                            toolbar: {
                                nRowsSelected: `${selectedRowsArray.length} order(s) selected`,
                                exportTitle: 'Export as Excel'
                            },
                            header: {
                                actions: ''
                            },
                            body: {
                                emptyDataSourceMessage: 'No orders to display'
                            }
                        }}
                        components={{
                            Toolbar: some => (
                                <div className={classes.mtable}>
                                    <MTableToolbar {...some} />
                                </div>
                            )
                        }}
                        options={{
                            // filtering: true,
                            // paging: false,
                            pageSize: 10,
                            pageSizeOptions: [10, 25, 50, 100],
                            actionsColumnIndex: -1,
                            headerStyle: {
                                backgroundColor: '#757575',
                                color: '#fff',
                                padding: '0px',
                                textAlign: 'center'
                            },
                            rowStyle: {
                                padding: '0px 0px'
                            },
                            selection: true,
                            sorting: false,
                            selectionProps: (selecrowData: RowDataManufactur) => {
                                const checked = (selecrowData.status !== '14' && selecrowData.status !== '10') ? { checked: false } : {};
                                const check = (selectedRowsArray.find(_d => _d.orderno === selecrowData.orderno)?.orderno) ? { checked: true } : { checked: false };
                                return {
                                    disabled: (selecrowData.status !== '14' && selecrowData.status !== '10'),
                                    ...checked,
                                    ...check
                                };
                            }
                        }}
                        onSelectionChange={
                            (rows, rowData) => {
                                if (!rowData) {
                                    handleSelectAll(rows);
                                } else {
                                    handleSelectOne(rowData);
                                }
                            }
                        }
                        onChangePage={
                            (pageno) => {
                                setPage(pageno);
                            }
                        }
                        onChangeRowsPerPage={
                            (pageSize) => {
                                if (pageSize !== size) {
                                    if (pageSize > size) {
                                        setPage(prev => Math.min((Math.max((prev * pageSize) - pageSize, props.mfilteredOrderData.length / 5), 0)));
                                    } else {
                                        setPage(prev => Math.min((Math.max((prev * pageSize) + pageSize, props.mfilteredOrderData.length / 5), 0)));
                                    }
                                }
                                setSize(pageSize);
                            }
                        }
                        actions={[
                            {
                                icon: () => (
                                    (!props.isDownloading ?
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            startIcon={<CloudDownloadIcon />}
                                        >
                                            Download Zip
                                        </Button>
                                        :
                                        <>
                                        </>
                                    )),
                                tooltip: 'Download zip files',
                                isFreeAction: false,
                                onClick: (event, rowdata) => {

                                    if (!props.isDownloading) {
                                        openDownloadDialog(rowdata, 'zip');
                                    }
                                }
                            },
                            {
                                icon: () => (
                                    (!props.isDownloading ?
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            startIcon={<CloudDownloadIcon />}
                                        >
                                            Download STL/PTS/3OX
                                        </Button>
                                        :
                                        <>
                                        </>
                                    )),
                                tooltip: 'Download STL/PTS/3OX files',
                                isFreeAction: false,
                                onClick: (event, rowdata) => {

                                    if (!props.isDownloading) {
                                        openDownloadDialog(rowdata, 'stl');
                                    }
                                }
                            }
                        ]}
                    />
                </Grid>
            </Grid>
            <Dialog
                open={openViewManufact}
                onClose={closePreviewPopup}
                aria-labelledby="Dialog-Order-Preview"
                fullWidth={fullWidth}
                maxWidth={maxWidthReason}
            >
                <DialogTitle id="form-dialog-title">
                    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '1.1rem' }}>
                        <div>Order Preview: {rowDataPreview.orderno}</div>
                        <div>Status: {rowDataPreview.customerstatus}</div>
                        {
                            rowDataPreview.completedon !== '' &&
                            <div>Completed On: {rowDataPreview.completedon}</div>
                        }
                    </div>
                </DialogTitle>
                <DialogContent dividers>
                    {
                        Array.isArray(props.previewOrderData.userRxdata) && props.previewOrderData.userRxdata.length > 0 &&
                        <Typography variant="subtitle1">
                            Case Details :
                        </Typography>
                    }
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            {
                                Array.isArray(props.previewOrderData.userRxdata) && props.previewOrderData.userRxdata.length > 0 &&
                                <div className={classes.tabpanel}>
                                    <TableContainer component={Paper}>
                                        <Table className={classes.table} size="small" aria-label="simple table">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>Design Type</TableCell>
                                                    <TableCell align="right">Tooth</TableCell>
                                                    <TableCell align="right">Material</TableCell>
                                                    <TableCell align="right">Model</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {Array.isArray(props.previewOrderData.userRxdata) && props.previewOrderData.userRxdata.length > 0 &&
                                                    props.previewOrderData.userRxdata.map((rxDetail, iRx) => (
                                                        <TableRow key={iRx}>
                                                            <TableCell component="th" scope="row">
                                                                {rxDetail.designtype}
                                                            </TableCell>
                                                            <TableCell align="right">{rxDetail.notations}</TableCell>
                                                            <TableCell align="right">{rxDetail.materialname}</TableCell>
                                                            <TableCell align="right">{rxDetail.model}</TableCell>
                                                        </TableRow>
                                                    ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </div>
                            }
                        </Grid>
                    </Grid>
                    <br />
                    {
                        Array.isArray(props.previewOrderData.getFileData) && props.previewOrderData.getFileData.length > 0 &&
                        <Typography variant="subtitle1">
                            Files :
                        </Typography>
                    }
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            {
                                Array.isArray(props.previewOrderData.getFileData) && props.previewOrderData.getFileData.length > 0 &&
                                <div className={classes.tabpanel}>
                                    <TableContainer component={Paper}>
                                        <Table className={classes.table} size="small" aria-label="simple table">
                                            <TableBody>
                                                {fileTypesView.map((fileType, index) => (
                                                    fileRender1(fileType) !== 'No Data' ?
                                                        <TableRow key={`id_${index}`}>
                                                            <TableCell component="th" scope="row">
                                                                <div className={classes.previewOrderfont}>
                                                                    {fileType === 'STL File' ? 'STL Files' : fileType}
                                                                </div>
                                                            </TableCell>
                                                            <TableCell component="th" scope="row">
                                                                <div className={classes.previewOrderfont}>
                                                                    {fileRender1(fileType)}
                                                                </div>
                                                            </TableCell>
                                                            <TableCell component="th" scope="row">
                                                                {fileType === 'STL File' ?
                                                                    <IconButton
                                                                        color="primary"
                                                                        size="small"
                                                                        onClick={() => openStlSelect(props.previewOrderData.getFileData)}
                                                                        aria-label="view stl"
                                                                    >
                                                                        <ThreeDRotationIcon />
                                                                    </IconButton>
                                                                    : null}
                                                            </TableCell>
                                                        </TableRow>
                                                        : null
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </div>
                            }
                        </Grid>
                    </Grid>
                    <br />
                    <Typography variant="subtitle1">
                        Instructions :
                    </Typography>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Paper>
                                <CssTextField
                                    id="casenotes"
                                    fullWidth
                                    disabled
                                    multiline
                                    defaultValue="No Instructions found"
                                    variant="outlined"
                                    value={props.previewOrderData.caseNotes !== '' ? props.previewOrderData.caseNotes : 'No Instructions found'}
                                />
                            </Paper>
                        </Grid>
                    </Grid>
                    <br />
                    {
                        Array.isArray(props.previewOrderData.getUserMessage) && props.previewOrderData.getUserMessage.length > 0 &&
                        <Typography variant="subtitle1">
                            Messages :
                        </Typography>
                    }
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            {
                                Array.isArray(props.previewOrderData.getUserMessage) && props.previewOrderData.getUserMessage.length > 0 &&
                                <ScrollToBottom className={classes.container}>{chatBubbles}</ScrollToBottom>
                            }
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button
                        variant="outlined"
                        size="small"
                        onClick={closePreviewPopup}
                        color="secondary"
                    >
                        close
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={openStlview}
                onClose={closeStlSelect}
            >
                <DialogTitle id="form-dialog-title-reasons">Select STL files to be viewed</DialogTitle>
                <DialogContent dividers>
                    <Grid container spacing={2}>
                        <div className={classes.reasonBox}>
                            {
                                allStls.map((stls, indexStls) => (
                                    <Grid item xs={12} sm={12} md={12}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    id={`selectedstls${indexStls}`}
                                                    checked={selectedstlsString.indexOf(stls.filename) !== -1 ? true : false}
                                                    value={stls.filename}
                                                    onChange={onSelectstl}
                                                    name="category"
                                                />
                                            }
                                            label={stls.filename.split('/').reverse()[0]}
                                        />
                                    </Grid>
                                ))
                            }
                        </div>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button size="small" onClick={closeStlSelect} color="secondary">
                        Cancel
                    </Button>
                    <Button
                        size="small"
                        onClick={submitStlSelect}
                        disabled={selectedstls.length > 0 ? false : true}
                        color="primary"
                    >
                        View STLs
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default MFilterLessOrderView;



// WEBPACK FOOTER //
// ./src/components/layouts/MFilterLessOrderView.tsx